var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExerciseCore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 4.99992C3.3335 4.08325 4.0835 3.33325 5.00016 3.33325C5.91683 3.33325 6.66683 4.08325 6.66683 4.99992C6.66683 5.91659 5.91683 6.66659 5.00016 6.66659C4.0835 6.66659 3.3335 5.91659 3.3335 4.99992ZM0.833496 7.49992H5.8335L11.6668 3.33325L12.7585 4.59992L9.2835 7.08325H11.6668L18.1668 3.33325L19.1668 4.49992L12.0835 9.99992L11.6668 18.3333H10.0002L9.5835 9.99992L6.66683 9.16659H0.833496V7.49992Z",
    fill: "#2F54EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExerciseCore);
export default __webpack_public_path__ + "static/media/icon_exercise_core.5861ac72bb64246f399cfa6db75fe9f7.svg";
export { ForwardRef as ReactComponent };